/**
 * ==============================================================================
 * BRELIL COLOMBIA - REGLA DE ENVÍO GRATIS EXCLUSIVO PARA VALLE DE ABURRÁ
 * Municipios autorizados: Medellín, Itagüí, Sabaneta, Bello, Envigado
 * ==============================================================================
 */
(function() {
  'use strict';

  var MUNICIPIOS_VALIDOS = ['medellin', 'itagui', 'sabaneta', 'bello', 'envigado'];

  function normalize(str) {
    if (!str) return '';
    return str.toString().trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function esValleAburra(ciudad) {
    if (!ciudad) return false;
    var norm = normalize(ciudad);
    for (var i = 0; i < MUNICIPIOS_VALIDOS.length; i++) {
      if (norm.indexOf(MUNICIPIOS_VALIDOS[i]) !== -1) {
        return true;
      }
    }
    return false;
  }

  function auditarMetodosEnvio() {
    // 1. Detectar ciudad actual en cualquier campo de dirección/ciudad
    var inputs = document.querySelectorAll('input[name*="city" i], select[name*="city" i], #AddressCity, .shipping-city-input');
    var ciudadDetectada = '';
    inputs.forEach(function(el) {
      if (el.value && el.value.trim().length > 0) {
        ciudadDetectada = el.value;
      }
    });

    var esPermitido = ciudadDetectada ? esValleAburra(ciudadDetectada) : true;

    // 2. Buscar opciones de envio gratis en medellin
    var opciones = document.querySelectorAll('input[type="radio"], option, .shipping-rate, [data-shipping-rate]');
    
    opciones.forEach(function(el) {
      var texto = (el.value || '') + ' ' + (el.textContent || '') + ' ' + (el.getAttribute('data-shipping-title') || '');
      var normTexto = normalize(texto);
      
      var esEnvioGratisMedellin = (normTexto.indexOf('gratis') !== -1 || normTexto.indexOf('free') !== -1) && 
                                  (normTexto.indexOf('medellin') !== -1 || normTexto.indexOf('local') !== -1 || normTexto.indexOf('aburra') !== -1);
      
      if (esEnvioGratisMedellin) {
        var contenedor = el.closest('li, .radio-wrapper, .shipping-option, tr, .form-check') || el.parentElement;
        var avisoExistente = contenedor ? contenedor.querySelector('.brelil-shipping-notice') : null;

        if (ciudadDetectada && !esPermitido) {
          // Bloquear opción
          el.disabled = true;
          if (el.checked) {
            el.checked = false;
            // Seleccionar otra tarifa de pago disponible
            var alternativa = document.querySelector('input[type="radio"]:not([disabled])');
            if (alternativa) alternativa.checked = true;
          }
          if (contenedor) {
            contenedor.style.opacity = '0.45';
            contenedor.style.pointerEvents = 'none';
            if (!avisoExistente) {
              var aviso = document.createElement('div');
              aviso.className = 'brelil-shipping-notice';
              aviso.style.cssText = 'color: #b91c1c; font-size: 1.15rem; font-weight: 600; margin-top: 4px; line-height: 1.3; pointer-events: auto;';
              aviso.textContent = '⚠️ Envío gratis disponible exclusivamente en Medellín, Itagüí, Sabaneta, Bello y Envigado.';
              contenedor.appendChild(aviso);
            }
          }
        } else {
          // Habilitar opción
          el.disabled = false;
          if (contenedor) {
            contenedor.style.opacity = '1';
            contenedor.style.pointerEvents = 'auto';
            if (avisoExistente) avisoExistente.remove();
          }
        }
      }
    });
  }

  // Ejecución inicial y listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', auditarMetodosEnvio);
  } else {
    auditarMetodosEnvio();
  }

  document.addEventListener('change', auditarMetodosEnvio);
  document.addEventListener('input', auditarMetodosEnvio);

  // Observador para cambios dinámicos en el carrito y Drawer
  var observer = new MutationObserver(function() {
    auditarMetodosEnvio();
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
